<div class="main">
  @if (hasError) {
    <div class="column twelve lg-eight lg-push-two md-eight md-push-two">
      <ds-error-message [errorList]="errorList"></ds-error-message>
    </div>
  }

  <div class="row pad-top-20">
    <div class="column twelve lg-eight lg-push-two md-eight md-push-two">
      <div></div>
    </div>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
</div>
